/* CHARÉE — Maison · maison.js
   Progressive enhancement only. Everything works without this file.
   No third-party requests, no storage on the device, no tracking. */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var body = doc.body;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 0 · The hour. Local time becomes a mood between dawn (0) and dusk (1); there is no night. */
  function mood() {
    var d = new Date();
    var h = d.getHours() + d.getMinutes() / 60;
    if (h < 5) { return 1; }
    if (h < 8) { return (h - 5) / 3 * 0.25; }
    if (h < 16) { return 0.25 + (h - 8) / 8 * 0.3; }
    if (h < 20.5) { return 0.55 + (h - 16) / 4.5 * 0.45; }
    return 1;
  }
  var OFFSETS = { hour: 0, dawn: -0.18, day: 0, dusk: 0.22 };
  var STOPS = [ /* mood, light-a rgba, light-b rgba, x, y */
    [0,    [214, 181, 118, 0.17], [181, 150, 95, 0.07], 64, 26],
    [0.45, [201, 170, 108, 0.11], [181, 150, 95, 0.05], 50, 10],
    [1,    [148, 118, 68, 0.19],  [128, 106, 67, 0.09], 36, 34]
  ];
  function lerp(a, b, t) { return a + (b - a) * t; }
  function stopsAt(m) {
    var a = STOPS[0], b = STOPS[1];
    if (m > STOPS[1][0]) { a = STOPS[1]; b = STOPS[2]; }
    var t = (m - a[0]) / (b[0] - a[0]);
    function col(i) { return 'rgba(' + Math.round(lerp(a[i][0], b[i][0], t)) + ',' + Math.round(lerp(a[i][1], b[i][1], t)) + ',' + Math.round(lerp(a[i][2], b[i][2], t)) + ',' + lerp(a[i][3], b[i][3], t).toFixed(3) + ')'; }
    return { a: col(1), b: col(2), x: lerp(a[3], b[3], t).toFixed(1) + '%', y: lerp(a[4], b[4], t).toFixed(1) + '%' };
  }
  function applyMood(m) {
    var s = stopsAt(m);
    root.style.setProperty('--light-a', s.a);
    root.style.setProperty('--light-b', s.b);
    root.style.setProperty('--light-x', s.x);
    root.style.setProperty('--light-y', s.y);
    root.dataset.mood = m.toFixed(3);
    try { root.dispatchEvent(new CustomEvent('charee:light', { detail: { mood: m } })); } catch (err) { /* older engines */ }
  }
  var hourMood = mood();
  applyMood(hourMood);
  window.CHAREE = { mood: hourMood };

  var menu = doc.querySelector('details.menu');

  /* 1 · Reveal on entry. Only elements outside the viewport when this script runs are armed (hidden);
     whatever is visible on arrival stays visible. Without this script nothing is ever hidden. */
  var reveals = doc.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    var vh = window.innerHeight || root.clientHeight;
    reveals.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top >= vh * 0.9 || r.bottom <= 0) { el.classList.add('is-armed'); io.observe(el); }
    });
  }

  /* 2 · Home: the wordmark enters once the mark has been left */
  var hero = doc.querySelector('.home .hero');
  if (hero && 'IntersectionObserver' in window) {
    var heroIo = new IntersectionObserver(function (entries) {
      body.classList.toggle('is-scrolled', !entries[0].isIntersecting);
    }, { threshold: 0.35 });
    heroIo.observe(hero);
  } else if (hero) {
    body.classList.add('is-scrolled');
  }

  /* 2a · The header steps back while she reads down and returns when she looks up */
  var lastY = window.pageYOffset || 0, ticking = false;
  function onScroll() {
    var y = window.pageYOffset || 0;
    var menuOpen = menu && menu.open;
    body.classList.toggle('is-top', y < 8);
    if (!menuOpen && y > 160 && y > lastY + 6) { body.classList.add('is-hidden-header'); }
    else if (y < lastY - 6 || y <= 160) { body.classList.remove('is-hidden-header'); }
    lastY = y; ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); } }, { passive: true });
  body.classList.toggle('is-top', lastY < 8);
  if (!hero) { body.classList.add('is-scrolled'); }
  else if (!('IntersectionObserver' in window)) { body.classList.add('is-scrolled'); }

  /* 2b · Chapters: the light changes with the chapter (geometry, not intersection) */
  var chapters = doc.querySelectorAll('.chapter[id]');
  var currentId = '';
  function chapterAt() {
    var line = (window.innerHeight || root.clientHeight) * 0.5;
    var found = null;
    for (var i = 0; i < chapters.length; i++) {
      var r = chapters[i].getBoundingClientRect();
      if (r.top <= line) { found = chapters[i]; }
    }
    return found || chapters[0] || null;
  }
  function syncChapter() {
    var line = (window.innerHeight || root.clientHeight) * 0.5;
    var inHero = hero ? hero.getBoundingClientRect().bottom > line : false;
    var c = inHero ? chapters[0] : chapterAt();
    var id = c ? c.id : '';
    if (id === currentId) { return; }
    currentId = id;
    var key = c ? (c.getAttribute('data-light') || 'hour') : 'hour';
    var off = OFFSETS[key] || 0;
    applyMood(Math.min(1, Math.max(0, hourMood + off)));
  }
  if (chapters.length) {
    window.addEventListener('scroll', function () { window.requestAnimationFrame(syncChapter); }, { passive: true });
    window.addEventListener('resize', syncChapter);
    syncChapter();
  }

  /* 3 · Mobile menu: close on Escape, close after navigation, lock scroll while open */
  if (menu) {
    menu.addEventListener('toggle', function () { root.style.overflow = menu.open ? 'hidden' : ''; });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
    });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { menu.open = false; }); });
  }

  /* 4 · Campaign continuity — controlled whitelist, nothing from the URL is ever rendered */
  var FILMS = ['01', '03', '04a', '04b', '05', '06a', '06b'];
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'campaign_id', 'creative_id', 'landing_variant'];
  var params;
  try { params = new URLSearchParams(window.location.search); } catch (err) { params = null; }

  function clean(v) { return (v || '').toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 40); }
  function film() { var f = params ? clean(params.get('film')) : ''; return FILMS.indexOf(f) > -1 ? f : ''; }
  function attribution() {
    var tags = [];
    var f = film();
    if (f) { tags.push('film:' + f); }
    if (params) { UTM_KEYS.forEach(function (k) { var v = clean(params.get(k)); if (v) { tags.push(k + ':' + v); } }); }
    return tags;
  }

  /* 4a · Waitlist page: continue the film */
  var filmDefault = doc.querySelector('[data-film-default]');
  if (filmDefault) {
    var f = film();
    var variant = f ? doc.querySelector('[data-film="' + f + '"]') : null;
    if (variant) {
      variant.hidden = false;
      variant.setAttribute('role', 'heading');
      variant.setAttribute('aria-level', '1');
      filmDefault.hidden = true;
      filmDefault.removeAttribute('id');
      variant.id = 'wl-title';
    }
    var tagsInput = doc.querySelector('[data-attribution]');
    if (tagsInput) {
      var extra = attribution();
      if (extra.length) { tagsInput.value = ['warteliste'].concat(extra).join(', '); }
    }
  }

  /* 4b · Other pages: carry whitelisted campaign parameters into the waitlist link only */
  var links = doc.querySelectorAll('[data-campaign-link]');
  if (links.length && params) {
    var carry = [];
    var f2 = film();
    if (f2) { carry.push('film=' + f2); }
    UTM_KEYS.forEach(function (k) { var v = clean(params.get(k)); if (v) { carry.push(k + '=' + encodeURIComponent(v)); } });
    if (carry.length) {
      links.forEach(function (a) {
        var href = a.getAttribute('href');
        a.setAttribute('href', href + (href.indexOf('?') > -1 ? '&' : '?') + carry.join('&'));
      });
    }
  }

  /* 5 · Forms: move focus to status after a round trip */
  var focusTarget = doc.querySelector('[data-focus-on-load]');
  if (focusTarget) {
    window.setTimeout(function () { try { focusTarget.focus({ preventScroll: false }); } catch (err) { focusTarget.focus(); } }, 50);
  }

  /* 6 · Quelle loop: load only on wide screens, without reduced motion, when in view; the still stays underneath */
  var loop = doc.querySelector('.figure-band__loop');
  if (loop && !reduceMotion && window.matchMedia('(min-width: 40.01em)').matches && 'IntersectionObserver' in window) {
    var loopIo = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) { return; }
      loopIo.disconnect();
      var canWebm = loop.canPlayType('video/webm; codecs="vp9"');
      var src = doc.createElement('source');
      src.src = canWebm ? loop.getAttribute('data-src-webm') : loop.getAttribute('data-src-mp4');
      src.type = canWebm ? 'video/webm' : 'video/mp4';
      loop.appendChild(src);
      loop.addEventListener('canplay', function () { loop.classList.add('is-ready'); }, { once: true });
      loop.addEventListener('timeupdate', function () { if (loop.currentTime >= 4.8) { loop.pause(); } });
      loop.load();
      var p = loop.play();
      if (p && p.catch) { p.catch(function () { loop.classList.remove('is-ready'); }); }
    }, { rootMargin: '200px 0px' });
    loopIo.observe(loop);
  }

  /* 7 · Campaign hero video: honour reduced motion (still only) */
  if (reduceMotion) {
    doc.querySelectorAll('video[data-reduced-motion-still]').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
  }

  /* 8 · The Maison's hour in the footer (Köln time) */
  var clock = doc.querySelector('[data-clock]');
  if (clock && window.Intl && Intl.DateTimeFormat) {
    var fmt;
    try { fmt = new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Berlin' }); } catch (err) { fmt = null; }
    if (fmt) {
      var tick = function () { clock.textContent = fmt.format(new Date()); };
      tick();
      window.setInterval(tick, 30000);
    }
  }
})();
